/**
 * @flow
 */
import styled from 'react-emotion'
import { mobile } from '../../../../utils/mixins'

export const BookNowButtonContainer = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 10px;
`

export const BookNowButton = styled('button')`
  font-size: 14px;
  background-color: rgb(244, 116, 0);
  padding: 10px 20px;
  color: #ffffff;
  border: none;
  cursor: pointer;
  width: 120px;
  height: 40px;
  ${mobile} {
    margin-left: auto;
    margin-right: auto;
    text-transform: uppercase;
    padding: 10px 10px;
    max-height: 38px;
  }
`

export const ButtonSupportText = styled('p')`
  font-family: din-2014;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  opacity: 0.8;
  font-size: 13px;
  font-style: italic;
  color: #ffffff;
  text-align: center;
  position: relative;
  line-height: unset;
  padding-left: 0;
  padding-right: 0;
  padding-top: 10px;
`



// WEBPACK FOOTER //
// ./src/components/IbcArcade/TestimonialSection/TestimonialFooter/styledComponents.js